import { useEffect } from 'react';
import { useUpdateNodeInternals, type NodeProps } from '@xyflow/react';
import BaseNode from './BaseNode';
import { type DecisionNodeData } from '@app/services/aiFlow.types';

function DecisionNode(props: NodeProps) {
    const { data, id } = props;
    const decisionData = data as DecisionNodeData;
    const updateNodeInternals = useUpdateNodeInternals();
    useEffect(() => {
        updateNodeInternals(id);
    }, [data.visConditionSlots, id, updateNodeInternals]);

    return (
        <BaseNode
            id={id}
            type="decision"
            content={decisionData.name}
            visConSlots={decisionData.visConditionSlots}
        />
    );
}

export default DecisionNode;
